import { addDays } from './dates';
import { dl, MUTED, NEUTRAL } from './format';

// "Compare with": the previous week, or the first logged week (the first week
// in the window with any gut symptom or bowel row — never called "Baseline").

export const COMPARE_OPTIONS = [
  ['prev', 'Previous week'],
  ['first', 'First logged week'],
];

/** Options for a segmented switch: `[[key, label]]` → `[{ key, label, active }]`. */
export const options = (opts, active) => opts.map(([key, label]) => ({ key, label, active: key === active }));

/** The Monday of the week the selected week `ws` is compared with. */
export const refWeek = (ctx, ws, cmp) => (cmp === 'first' && ctx.firstWeek ? ctx.firstWeek : addDays(ws, -7));

/**
 * What the selected week is compared with.
 * - `same`: the selected week *is* the first logged week, so every delta reads "First logged week".
 */
export function compareWith(ctx, ws, cmp) {
  const refWs = refWeek(ctx, ws, cmp);
  return {
    ws,
    refWs,
    same: ws === ctx.firstWeek,
    word: cmp === 'first' ? 'first logged week' : 'last week',
    cur: ctx.week(ws),
    ref: ctx.week(refWs),
  };
}

/**
 * A KPI note comparing `c` (selected week) with `r` (compared week): "↓ 0.4 vs last week".
 * @param {{ dir: number, fmt: (v: number) => string, unit?: string, whole?: boolean }} how -
 *   `dir` 1 when up is better, −1 when down is better; `unit` follows the number (" pp");
 *   `whole` rounds the change to a whole number first (percentages).
 * @returns {[string, string]} text and colour.
 */
export function weekDelta(cmp, c, r, { dir, fmt, unit = '', whole = false }) {
  if (cmp.same) return ['First logged week', MUTED];
  if (c == null || r == null) return ['Not enough data to compare', NEUTRAL];
  const [d, colour] = dl(whole ? Math.round(c - r) : c - r, dir, fmt);
  return [d === 'No change' ? `No change vs ${cmp.word}` : `${d}${unit} vs ${cmp.word}`, colour];
}
